export const ACTION = {
    ON_VIDEO_PROGRESS: 'OnVideoProgress',
    ON_VIDEO_LOADED: 'OnVideoLoaded',
    ON_LIVE_VIDEO_PAUSED: 'OnLiveVideoPaused',
    ON_VIDEO_SEEKED: 'OnLiveVideoSeeked',
    ON_PLAYER_OVERLAY_PRESS: 'OnPlayerOverlayPress',
    ON_PLAYER_SEEK: 'onPlayerSeek',
    ON_EPG_FILTER_TOGGLER_PRESS: 'onEpgFilterTogglerPress',
    ON_VIDEOSTORE_FILTER_TOGGLER_PRESS: 'onVideostoreFilterTogglerPress',
    ON_EPG_DATE_SELECT: 'onEpgDateSelect',
    ON_DETAILS_SEASON_SELECTOR_PRESS: 'ON_DETAILS_SEASON_TOGGLER_PRESS',
    ON_DETAILS_SEASON_SELECTED: 'ON_DETAILS_SEASON_SELECTED'
};
